export const ComplimentIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width={40} height={40} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g clipPath="url(#clip0_78_2670)">
        <path
          d="M20.0002 39.1663C30.5856 39.1663 39.1668 30.5851 39.1668 19.9997C39.1668 9.41422 30.5856 0.833008 20.0002 0.833008C9.41471 0.833008 0.833496 9.41422 0.833496 19.9997C0.833496 30.5851 9.41471 39.1663 20.0002 39.1663Z"
          fill="#10B981"
        />
        <path
          d="M20.0002 7.49967C24.1409 7.49999 28.1851 8.75057 31.6032 11.0877C35.0213 13.4248 37.6541 16.7396 39.1568 20.598C39.1568 20.398 39.1668 20.1997 39.1668 19.9997C39.1668 14.9164 37.1475 10.0412 33.553 6.44679C29.9586 2.85235 25.0835 0.833008 20.0002 0.833008C14.9168 0.833008 10.0417 2.85235 6.44728 6.44679C2.85284 10.0412 0.833496 14.9164 0.833496 19.9997C0.833496 20.1997 0.833496 20.398 0.843496 20.598C2.34626 16.7396 4.97904 13.4248 8.39715 11.0877C11.8153 8.75057 15.8594 7.49999 20.0002 7.49967Z"
          fill="#ECFDF5"
        />
        <path
          d="M8.94836 22.5C10.0107 24.5102 11.6011 26.1925 13.5485 27.366C15.4959 28.5395 17.7264 29.1596 20 29.1596C22.2736 29.1596 24.5042 28.5395 26.4516 27.366C28.3989 26.1925 29.9894 24.5102 31.0517 22.5"
          stroke="#00303E"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M20.0002 39.1663C30.5856 39.1663 39.1668 30.5851 39.1668 19.9997C39.1668 9.41422 30.5856 0.833008 20.0002 0.833008C9.41471 0.833008 0.833496 9.41422 0.833496 19.9997C0.833496 30.5851 9.41471 39.1663 20.0002 39.1663Z"
          stroke="#00303E"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.1665 13.3331C9.73077 12.5381 10.482 11.8942 11.354 11.4582C12.226 11.0222 13.1919 10.8075 14.1665 10.8331"
          stroke="#00303E"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M30.8335 13.3331C30.2692 12.5381 29.518 11.8942 28.646 11.4582C27.774 11.0222 26.8081 10.8075 25.8335 10.8331"
          stroke="#00303E"
          strokeWidth="1.66667"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_78_2670">
          <rect width={40} height={40} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
